export default __webpack_public_path__ + "static/media/costPriceAdd.58a11626.xlsx";